export default [
    {path: ':fiscal_year'},
    {path: ':fiscal_year/edit/:item_id'} ,
    {path: ':fiscal_year/details/:item_id'} ,
]